import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bindAll } from '@bibliocommons/utils-react';
import {
  InlineOverlay,
  InlineOverlayHeader,
  InlineOverlayFooter,
  InlineOverlayBody,
  InlineOverlayCloseButton
} from '@bibliocommons/base-inline-overlay';
import { TransactionalButton } from '@bibliocommons/deprecated-base-buttons';
import { Checkmark } from '@bibliocommons/deprecated-base-icons';
import { GenericForm } from '@bibliocommons/shared-messages';
import BibBrief from 'app/components/shared/BibBrief';
import { bibBriefShape } from '@bibliocommons/bc-prop-types';

/* eslint-disable import/no-extraneous-dependencies */
import MessagingContainer from 'app/components/Messaging/MessagingContainer';
/* eslint-enable import/no-extraneous-dependencies */
import DigitalFormats from '../../digital-formats';

export class DigitalMissingFormatWorkflowView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      format: null
    };
    bindAll(this);
  }

  handleFormatSelect(format) {
    this.setState({ format });
  }

  handleFormatLockIn() {
    const { format } = this.state;
    const { accountId, checkout, bib, messagingId, workflowId } = this.props;

    if (format) {
      this.props.lockInFormat({
        accountId,
        checkoutId: checkout.get('checkoutId'),
        format: format.get('name'),
        metadataId: bib.get('id'),
        messagingId,
        workflowId
      });
    }
  }

  render() {
    const { handleClose, bib, isLoading, formats, provider } = this.props;
    return (
      <InlineOverlay handleClose={handleClose}>
        <InlineOverlayHeader>
          <FormattedMessage id="digital_title_is_available" values={{ title: bib.get('title') }} />
        </InlineOverlayHeader>
        <InlineOverlayBody>
          <MessagingContainer id={bib.get('id')}>
            {messageOptions => <GenericForm {...messageOptions} />}
          </MessagingContainer>
          <BibBrief bib={bib} titleTag="h3" />
          <DigitalFormats
            formats={formats}
            provider={provider}
            selectable
            isAvailable
            onSelectFormat={this.handleFormatSelect}
            metadataId={bib.get('id')}
            fetchDigitalFormats={this.props.fetchDigitalFormats}
          />
        </InlineOverlayBody>
        <InlineOverlayFooter>
          <TransactionalButton
            data-test-id="missing-format-checkout-now"
            className="pull-right"
            isLoading={isLoading}
            handleClick={this.handleFormatLockIn}
            disabled={!this.state.format}
          >
            <Checkmark color="#FFF" /> <FormattedMessage id="check_out_now" />
          </TransactionalButton>
          <InlineOverlayCloseButton className="btn btn-link pull-right">
            <FormattedMessage id="button_nevermind_close" />
          </InlineOverlayCloseButton>
        </InlineOverlayFooter>
      </InlineOverlay>
    );
  }
}

DigitalMissingFormatWorkflowView.propTypes = {
  workflowId: PropTypes.string,
  messagingId: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  bib: bibBriefShape.isRequired,
  isLoading: PropTypes.bool,
  formats: ImmutablePropTypes.listOf(
    ImmutablePropTypes.contains({
      name: PropTypes.string,
      hasDownloadLink: PropTypes.bool
    })
  ),
  lockInFormat: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  checkout: ImmutablePropTypes.contains({
    checkoutId: PropTypes.string
  }).isRequired,
  provider: PropTypes.string,
  fetchDigitalFormats: PropTypes.func.isRequired
};

DigitalMissingFormatWorkflowView.displayName = 'DigitalMissingFormatWorkflowView';

export default DigitalMissingFormatWorkflowView;
